export default "__VITE_ASSET__97996e57__"